"use strict";

angular.module("customer")
.controller("SectionFullRegistration", function(
    $scope, $rootScope, $state, $stateParams, gettextCatalog, FlashBag, FormError, $http, Language, PartnershipService,
    GroupService, UserService, PatternService, RegistrationService, CUSTOMER_TYPE_REGISTRATION, CUSTOMER_TYPE, IS_MOBILE,
    IS_TABLET, EMAIL_MAXLENGTH, appConfig
) {
    var _this = this;
    $scope.EMAIL_MAXLENGTH = EMAIL_MAXLENGTH;
    $scope.isCustomerTypeBusiness = CUSTOMER_TYPE_REGISTRATION == CUSTOMER_TYPE["BUSINESS"];
    $scope.isArray = angular.isArray;
    $scope.isMobileRegistration = IS_MOBILE && !IS_TABLET;

    if ($stateParams.token) {
        $scope.User = RegistrationService.fillUserWithTokenInvitationInfo($stateParams.token);
    }
    else {
        RegistrationService.checkForAutoRedirectPage();
        $scope.User = {
            Token: "",
            departments: []
        };
    }

    /* WEG-1788: temporary fix until the racing condition is solved
    // TODO WEG-1791: Activate the feature again
    if ($stateParams.vendorInvite) {
        RegistrationService.fillDepartmentsWithVendorInviteToken($stateParams.vendorInvite)
        .then(function onSuccess(response) {
            $scope.User.departments = response.data;
            $scope.SetRegister.departments = $scope.User.departments.toString();
        });
    }
    */

    $scope.pattern = PatternService;
    Language.getLanguages().then(function(response) {
        $scope.Languages = response.data;
    });
    $scope.shippingIsSameAsBilling = true;

    function applyShippingAndBillingSameAddress() {
        if ($scope.shippingIsSameAsBilling) {
            $scope.User.BillingAddress = $scope.User.ShippingAddress;
            $scope.User.BillingCity = $scope.User.ShippingCity;
            $scope.User.BillingProvinceName = $scope.User.ShippingProvinceName;
            $scope.User.BillingProvinceCode = $scope.User.ShippingProvinceCode;
            $scope.User.BillingPostalCode = $scope.User.ShippingPostalCode;
            $scope.User.BillingCountryName = $scope.User.ShippingCountryName;
            $scope.User.BillingCountryCode = $scope.User.ShippingCountryCode;
        }
    }

    $scope.$watch("shippingIsSameAsBilling", function(newValue, oldValue) {
        if (oldValue == null) return; // return when the first load is done

        if (newValue) {
            applyShippingAndBillingSameAddress();
        }
        else {
            $scope.User.BillingAddress = "";
            $scope.User.BillingCity = "";
            $scope.User.BillingProvinceName = "";
            $scope.User.BillingProvinceCode = "";
            $scope.User.BillingPostalCode = "";
            $scope.User.BillingCountryName = "";
            $scope.User.BillingCountryCode = "";
        }
    });

    this.create = function() {
        FlashBag.clearAll();
        applyShippingAndBillingSameAddress();

        $scope.isFormSubmit = true;
        this.validate();

        if (!$scope.SetRegister) {
            return;
        }

        if (
            $scope.SetRegister.$valid
            || ($scope.SetRegister.Username.$error.invalid || $scope.SetRegister.Email.$error.used)
        ) {
            this.validateZoneKey();
        }
    };

    // On form submit, focus on the first error element
    this.validate = function() {
        FormError.focus("SetRegister");
    };

    this.validateZoneKey = function() {
        $http({
            method: "POST",
            url: appConfig.API_SERVER + "/market/zones/build/",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            data: $.param({
                city: $scope.User.ShippingCity,
                province: $scope.User.ShippingProvinceName,
                postalCode: $scope.User.ShippingPostalCode,
                countryName: $scope.User.ShippingCountryName
            })
        }).then(
            function success(resp) {
                if (resp.data.split(";").length >= 3)
                    _this.RegisterUser(resp.data);
                else
                    FlashBag.preformattedError(gettextCatalog.getString("Your address is difficult to validate. Pay attention to the spelling with the displayed language or write us to support@wego.trade to assist you."), false);
            },
            function failed(resp) {
                FlashBag.apiError(resp);
            }
        );
    };

    this.saveZoneKey = function(key, objID) {
        $http({
            url: appConfig.API_SERVER + "/market/zones/save/",
            method: "POST",
            headers: {"Content-Type": "application/x-www-form-urlencoded"},
            data: $.param({
                refID: objID,
                refType: "retailer",
                zonesKey: key
            })
        }).then(
            function success(resp) {
            },
            function failed(resp) {
                FlashBag.apiError(resp);
            }
        );
    };

    //Register user
    this.RegisterUser = function(zoneKey) {
        $http({
            method: "POST",
            url: appConfig.API_SERVER + "/auth/user/",
            data: angular.extend({}, {
                Action: "Register",
                RegistrationType: "Customer",
                groupInvite: $stateParams.groupInvite,
                customer_type: CUSTOMER_TYPE_REGISTRATION,
                vendorInvite: $stateParams.vendorInvite,
                vendor: $stateParams.vendor || $stateParams.stocks,
                is_mobile_registration: $scope.isMobileRegistration
            }, $scope.User)
        }).then(
            function success(response) {
                UserService.persistAuthTokenWithoutUserRefresh(response);
                if (response.data.companyID) {
                    _this.saveZoneKey(zoneKey, response.data.companyID);
                }

                if ($stateParams.vendorInvite) {
                    PartnershipService.add({"vendorInvite": $stateParams.vendorInvite}).then(
                        function success(response) {
                            FlashBag.success(response.detail, true);
                        },
                        function failed(response) {
                            FlashBag.apiError(response, true);
                        }
                    );
                }

                GroupService.addCustomerGroupMembershipFromRegistration($stateParams.groupInvite);
                FlashBag.success(gettextCatalog.getString("The user was created successfully, please login."), true);

                UserService.refreshCurrentUser().then(function() {
                    if ($stateParams.stocks) {
                        $state.go("stocks", {vendor: $stateParams.stocks, catalog: $stateParams.catalog});
                    }
                    else if ($stateParams.vendor) {
                        $state.go("stocks", {vendorId: $stateParams.vendor});
                    }
                    else if ($stateParams.product) {
                        $state.go("stocks", {product: $stateParams.product});
                    }
                    else if ($stateParams.invoice) {
                        $state.go("invoiceDetails", {id: $stateParams.invoice});
                    }
                    else if ($stateParams.payment) {
                        $state.go("paymentDetails", {id: $stateParams.payment});
                    }
                    else if ($stateParams.unpaid_invoices) {
                        $state.go("payment", {selected: $stateParams.unpaid_invoices});
                    }
                    else if (CUSTOMER_TYPE_REGISTRATION == CUSTOMER_TYPE["PERSON"]) {
                        $state.go("customer-edit")
                    }
                    else {
                        $state.go("home");
                    }
                });
            },
            function failed(response) {
                FlashBag.apiError(response);

                if (!$scope.SetRegister) {
                    return;
                }

                if (response.data["Email"]) {
                    $scope.SetRegister.Email.$setValidity("used", false);
                }
                else {
                    $scope.SetRegister.Email.$setValidity("used", true);
                }

                if (response.data["Username"]) {
                    $scope.SetRegister.Username.$setValidity("invalid", false);
                }
                else {
                    $scope.SetRegister.Username.$setValidity("invalid", true);
                }
            }
        );
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/auth/registration.controller.js
// module id = 893
// module chunks = 0